<div class="layout-column widget-container" [id]="widget.identification"
     [ngClass]="{'default-size': isLoadingData, 'table-widget': widget.widgetType === widgetTypeEnum.TableWidget}">
  <div class="layout-row layout-align-start-center padding-10">

    <bringoz-icon *ngIf="!isHideActions" iconName="drag" classSize="xl"
                  class="drag-handle margin-right-5"></bringoz-icon>

    <div class="layout-column">
      <div class="layout-row layout-align-start-center">
        <span class="br-body-2 font-weight-600 primary-100">{{ widget.name }}</span>
        <bringoz-icon *ngIf="!!widget.extraData?.description" iconName="info-outline"
                      class="primary-102 margin-left-5"
                      [ngbTooltip]="widgetDescription"
                      container="body"
                      openDelay="300"
                      triggers="hover"></bringoz-icon>
        <ng-template #widgetDescription>
          <span>{{ widget.extraData.description }}</span>
        </ng-template>
      </div>
      <div class="layout-row layout-align-start-center">
        <span *ngIf="lastRefreshDate" class="br-caption-1 gray-103 font-weight-400">
       {{ 'Updated at' | translate }}  {{ {lastRefreshDate: lastRefreshDate} | bringozDate: 'lastRefreshDate' }}  {{ {lastRefreshDate: lastRefreshDate}  | bringozTime: 'lastRefreshDate' }}
        </span>
        <branches-indicator *ngIf="widget.filters.branchIds" class="margin-left-5"
                            [branchIds]="widget.filters.branchIds"></branches-indicator>
      </div>
    </div>

    <span class="flex"></span>

    <app-bringoz-filters-button [filters]="widgetFilters"
                                [includeFilters]="includeFilters"
                                [optionIdsMap]="bringozFilterOptionIdsMap"
                                [queryMap]="dataSourceQueryMapEnum[widget.datasource]"
                                hideDisplay="true"
                                (onChange)="onFiltersChange($event.filters)">

    </app-bringoz-filters-button>

    <div *ngIf="!isHideActions || !isHideRefreshDataButton" class="layout-row layout-align-start-center">

      <button *ngIf="!isHideRefreshDataButton" class="refresh-btn" (click)="fetchData(false)"
              [disabled]="isRefreshButtonDisabled">
        <bringoz-icon appBringozIdGenerator="refreshWidget"
                      iconName="rotate"
                      [fill]="isRefreshButtonDisabled ? '#A3A3A3': '#6EAAF5'"></bringoz-icon>
      </button>

      <div *ngIf="!isHideActions" ngbDropdown container="body" class="actions-menu">
        <button id="actionsMenu"
                appBringozIdGenerator="openWidgetMenu"
                (click)="$event.stopPropagation();"
                ngbDropdownToggle>
          <bringoz-icon iconName="menu"></bringoz-icon>
        </button>
        <div ngbDropdownMenu aria-labelledby="actionsMenu">
          <button ngbDropdownItem
                  (click)="onEditWidget()">
            <span class="br-body-2 primary-100" translate>Edit Widget</span>
          </button>

          <button ngbDropdownItem
                  (click)="onDeleteWidget()">
            <span class="br-body-2 primary-100" translate>Delete Widget</span>
          </button>

        </div>
      </div>

    </div>
  </div>
  <hr class="margin-0 secondary-101">
  <ng-container *ngIf="(!isLoadingData && data) || widget.widgetType === widgetTypeEnum.TableWidget">

    <!--    <div *ngIf="canSearch" class="layout-row layout-align-start-center padding-10">-->
    <!--      <app-bringoz-search-input class="flex-40"-->
    <!--                                [query]="queryParams.query"-->
    <!--                                placeholder="Search Agent"-->
    <!--                                minLength="3"-->
    <!--                                (queryChangeEvent)="onQueryChange($event)">-->
    <!--      </app-bringoz-search-input>-->
    <!--    </div>-->

    <div
      *ngIf="widget.widgetType === widgetTypeEnum.NumberWidget || widget.widgetType === widgetTypeEnum.PieChartWidget"
      class="flex layout-row layout-align-start-center">
      <div *ngFor="let metric of widget.metrics | keyvalue"
           class="padding-10 layout-row layout-align-center-center flex">
        <div class="flex layout-row layout-wrap layout-align-center-center">
          <div *ngFor="let item of metric.value; let last = last" class="layout-row margin-top-10">
            <div *ngIf="widget.widgetType === widgetTypeEnum.NumberWidget"
                 class="flex numeric-widget-wrapper">
              <app-bringoz-numeric-widget appBringozIdGenerator="numericWidget"
                                          [value]="widget.extraData?.displayType === 'percentage' ? ((!!data?.total ? (data[item.metricValue] / data.total) : 0) * 100).toFixed(1) + '%' : data[item.metricValue]"
                                          [color]="dataSourceMetricColorEnum[widget.datasource][metric.key][item.metricValue]"
                                          [size]="2.75"
                                          (clickEvent)="onMetricValueClick(item.metricValue)">

              </app-bringoz-numeric-widget>
              <span appBringozIdGenerator="widgetStatusText"
                    class="font-weight-400 primary-100 widget-label"
                    translate>{{ 'METRIC_VALUES.' + item.metricValue }}</span>
            </div>
            <div *ngIf="widget.widgetType === widgetTypeEnum.PieChartWidget"
                 class="flex pie-widget-wrapper">
              <app-bringoz-donut-chart
                [innerTextConfiguration]="widgetPieChartSegmentsMap[metric.key][item.metricValue].innerTextConfiguration"
                [segments]="widgetPieChartSegmentsMap[metric.key][item.metricValue].segments"
                (clickEvent)="onMetricValueClick(item.metricValue)">
              </app-bringoz-donut-chart>
              <span class="font-weight-400 primary-100 margin-top-5 widget-label"
                    translate>{{ 'METRIC_VALUES.' + item.metricValue }}</span>
            </div>
            <div *ngIf="!last" class="vr widget-divider secondary-101"></div>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="widget.widgetType === widgetTypeEnum.TableWidget" class="flex layout-row">
      <app-agent-progress-table-widget class="flex table-widget"
                                       *ngIf="widget.datasource === widgetDataSourceType.agentsTracking"
                                       [widget]="widget"
                                       [data]="data"
                                       [dateRange]="{from: widgetFilters.from, to: widgetFilters.to}"
                                       (fetchNextEvent)="fetchNextTableWidgetData()">
      </app-agent-progress-table-widget>


      <app-dashboard-agents-route-score-table class="flex table-widget"
                                              *ngIf="widget.datasource === widgetDataSourceType.agentsRoutesScore"
                                              [agentsRouteScore]="data"
                                              [dateRange]="{from: widgetFilters.from, to: widgetFilters.to}"
                                              (fetchNextEvent)="fetchNextTableWidgetData()">
      </app-dashboard-agents-route-score-table>

    </div>

    <div *ngIf="widget.widgetType === widgetTypeEnum.MapWidget" class="flex layout-row">
      <app-agents-map class="flex map-widget"
                      *ngIf="widget.datasource === widgetDataSourceType.agentsLocations"
                      [agents]="data"
                      [branchIds]="widgetFilters.branchIds || dashboard.branchIds">
      </app-agents-map>

    </div>

    <div *ngIf="widget.widgetType === widgetTypeEnum.MetricsAverageWidget" class="flex layout-row">
      <div class="layout-column layout-align-center-center padding-10">
        <app-bringoz-donut-chart [innerTextConfiguration]="widgetPieChartTotalsSegments.innerTextConfiguration"
                                 [segments]="widgetPieChartTotalsSegments.segments"
                                 (clickEvent)="onMetricValueClick()">
        </app-bringoz-donut-chart>

        <span class="br-body-1 font-weight-400 primary-100" translate>Total Performance</span>
      </div>

      <div class="vr secondary-101 margin-left-10 margin-right-10"></div>

      <div class="layout-column layout-align-center-start">
        <div *ngFor="let metric of data | keyvalue" class="margin-bottom-10">
          <span
            class="br-body-1 font-weight-400 primary-100 margin-right-10">{{ 'METRIC_VALUES.' + metric.key | translate }}</span>
          <span class="br-body-1 font-weight-400 total-performance-metric"
                [class.good-score]="metric.value >= 80"
                [class.average-score]="metric.value > 60 && metric.value < 80"
                [class.bad-score]="metric.value <= 60"
          >{{ metric.value }}%</span>
        </div>
      </div>
    </div>

  </ng-container>

  <div *ngIf="isLoadingData && widget.widgetType !== widgetTypeEnum.TableWidget"
       class="flex layout-column layout-align-center-center fade-element-in-only">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <loader *ngIf="widget.widgetType === widgetTypeEnum.TableWidget" [isDisplayLoader]="isLoadingData"></loader>
</div>
